import { state } from "../../../store/state";
import { LAYER_SETTINGS_TYPES } from "../../constants";
import { WellSignsSvg } from "../icons";
import type { LayerPattern } from "..";
import { WellSignsSettings } from "./WellSignsSettings";

export const wellsSigns: LayerPattern = {
    id: "WellSigns",
    key: "well_base",
    title: "Скважины",
    icon: WellSignsSvg,
    widget: WellSignsSettings,
    pinned: true,
    settings: [

    ],
    settingsInit: () => ([
        {
            title: "Показывать подписи",
            key: "titleVisible",                    
            type: LAYER_SETTINGS_TYPES.CUSTOM,   
            defaultValue: true,     
            level: 0,
        },
        {
            title: "Размер подписи (коэф.)",
            key: "titleScaleFactor",        
            type: LAYER_SETTINGS_TYPES.CUSTOM,   
            defaultValue: 1,     
            level: 0,
        },
        {
            title: "wellBoreTypeIds",
            key: "wellBoreTypeIds",        
            type: LAYER_SETTINGS_TYPES.CUSTOM,   
            defaultValue: state.wellBoreType.map(({id}) => id),  
            level: 0,
        },
        {
            title: "wellBoreGeometryTypeIds",
            key: "wellBoreGeometryTypeIds",        
            type: LAYER_SETTINGS_TYPES.CUSTOM,   
            defaultValue: state.wellBoreGeometry.map(({id}) => id),  
            level: 0,
        },
        {
            title: "wellPositionVersionPriority",
            key: "wellPositionVersionPriority",        
            type: LAYER_SETTINGS_TYPES.CUSTOM,   
            defaultValue: state.wellBuildType.map(({id}) => id),  
            level: 0,
        },
    ]),
}





// {
//     "wellBoreTypeIds": [ 0, 1, 2, 3, ... ],
//     "wellBoreGeometryTypeIds": [ 0, 1, 2, 3, ... ],
//     "wellPositionVersionPriority": [ 0, 1 ], - важен порядок
// }